// extracted by mini-css-extract-plugin
module.exports = {"animationMarquee":"c_j"};